module.exports = __webpack_public_path__ + "static/media/bodybuilding.e84cd719.svg";